import type { FullTranslation } from "../../../lib/i18n"

export const CAMPAIGN_DETAIL_T = {
  pluginUsedBySequence: {
    FR: "Utilisé par la séquence",
    EN: "Used by the sequence",
  },
  pluginLockedBySequence: {
    FR: "Ce plugin ne peut pas être désactivé tant que la séquence y fait référence.",
    EN: "This plugin cannot be disabled while the sequence references it.",
  },
  demoBannerTitle: {
    FR: "Une campagne offerte, avec de vrais prospects",
    EN: "A free campaign, with real leads",
  },
  demoBannerDescription: {
    FR: "Ces entreprises ont été réellement trouvées et enrichies par nos agents, exactement comme elles le seraient pour vous. Nous vous les offrons : la campagne est en consultation seule.",
    EN: "These businesses were really found and enriched by our agents, exactly as they would be for you. They are yours to browse: the campaign is read-only.",
  },
  tabOverview: { FR: "Aperçu", EN: "Overview" },
  tabCrm: { FR: "CRM", EN: "CRM" },
  tabStats: { FR: "Stats", EN: "Stats" },
  tabCrmBadgeTooltipOne: {
    FR: "1 réponse de prospect que personne n'a encore ouverte.",
    EN: "1 prospect reply nobody has opened yet.",
  },
  tabCrmBadgeTooltipMany: {
    FR: "{count} réponses de prospects que personne n'a encore ouvertes.",
    EN: "{count} prospect replies nobody has opened yet.",
  },
  sectionResults: { FR: "Résultats", EN: "Results" },
  sectionResultsDesc: {
    FR: "Ce que la campagne a trouvé, et à quel point c'est exploitable.",
    EN: "What the campaign found, and how usable it is.",
  },
  sectionExtractions: { FR: "Extractions", EN: "Extractions" },
  sectionPipeline: { FR: "Pipeline CRM", EN: "CRM pipeline" },
  sectionPipelineDesc: {
    FR: "Où en sont les contacts dans la séquence, sur les 30 derniers jours.",
    EN: "Where contacts stand in the sequence, over the last 30 days.",
  },
  sectionUsage: { FR: "Consommation", EN: "Usage" },
  sectionUsageDesc: {
    FR: "Un crédit est débité à la collecte d'un prospect, pas à sa livraison.",
    EN: "A credit is charged when a lead is collected, not when it is delivered.",
  },
  costPerLeadDesc: {
    FR: "Débité pour chaque prospect collecté.",
    EN: "Charged for every lead collected.",
  },
  balanceFunds: {
    FR: "~{n} prospects supplémentaires sur cette campagne.",
    EN: "~{n} more leads on this campaign.",
  },
  contactable: { FR: "Joignables", EN: "Reachable" },
  contactableDesc: {
    FR: "Part des prospects avec un email ou un téléphone.",
    EN: "Share of leads carrying an email or a phone.",
  },
  newThisWeek: { FR: "Nouveaux cette semaine", EN: "New this week" },
  newThisWeekDesc: {
    FR: "Prospects trouvés sur les 7 derniers jours.",
    EN: "Leads found over the last 7 days.",
  },
  costPerLead: { FR: "Coût par prospect", EN: "Cost per lead" },
  campaigns: { FR: "Campagnes", EN: "Campaigns" },
  failedToLoadCampaign: {
    FR: "Impossible de charger la campagne",
    EN: "Failed to load campaign",
  },
  reloadThePage: { FR: "Rechargez la page", EN: "Reload the page" },
  noKeywords: { FR: "aucun mot-clé", EN: "no keywords" },
  noActivities: { FR: "aucune activité", EN: "no activity" },
  filterSingular: { FR: "filtre", EN: "filter" },
  filterPlural: { FR: "filtres", EN: "filters" },
  placeSingular: { FR: "lieu", EN: "place" },
  placePlural: { FR: "lieux", EN: "places" },
  edit: { FR: "Modifier", EN: "Edit" },
  campaignRenamed: { FR: "Campagne renommée", EN: "Campaign renamed" },
  renameFailed: {
    FR: "Impossible de renommer la campagne",
    EN: "Could not rename the campaign",
  },
  configTitle: { FR: "Configuration", EN: "Configuration" },
  configSubtitle: {
    FR: "La configuration de cette campagne. Les plugins et l'ordre de prospection restent modifiables, le reste est fixé à la création.",
    EN: "This campaign's configuration. Plugins and the prospecting order stay editable, everything else is set at creation.",
  },
  configNone: { FR: "Aucun", EN: "None" },
  decisionMakersRolesLabel: {
    FR: "Rôles recherchés en priorité",
    EN: "Roles to look for first",
  },
  decisionMakersRolesPlaceholder: {
    FR: "Ex. : les dirigeants et le directeur de la publication",
    EN: "E.g. the owners and the publication director",
  },
  decisionMakersRolesHint: {
    FR: "L'agent cherche ces rôles en premier, puis les autres décideurs.",
    EN: "The agent looks for these roles first, then the other decision-makers.",
  },
  decisionMakersRolesEmpty: {
    FR: "Tous les décideurs",
    EN: "Every decision-maker",
  },
  configAll: { FR: "Tous", EN: "All" },
  configDefault: { FR: "Par défaut", EN: "Default" },
  configCopy: { FR: "Dupliquer", EN: "Duplicate" },
  configTabTargeting: { FR: "Ciblage", EN: "Targeting" },
  configTabEnrichment: { FR: "Enrichissement", EN: "Enrichment" },
  configTabOutreach: { FR: "Envoi", EN: "Outreach" },
  configPluginsAvailable: { FR: "Disponibles", EN: "Available" },
  configPluginFixed: { FR: "Fixé", EN: "Fixed" },
  configPerLead: { FR: "par lead", EN: "per lead" },
  configPerWeek: { FR: "{n} par semaine", EN: "{n} per week" },
  allTargetsCovered: {
    FR: "Toutes les cibles couvertes",
    EN: "All targets covered",
  },
  allTargetsCoveredHelp1: {
    FR: "Toutes les sous-campagnes de cet ensemble mot-clé/lieu ont été parcourues. Ajoutez des lieux ou des mots-clés depuis",
    EN: "Every sub-campaign for this keyword/place set has been crawled. Add more places or keywords from",
  },
  allTargetsCoveredHelp2: {
    FR: "pour faire émerger de nouveaux leads.",
    EN: "to surface new leads.",
  },
  waitingForAgent: {
    FR: "En attente d'un agent disponible",
    EN: "Waiting for an available agent",
  },
  liveActivityHelp: {
    FR: "Les nouveaux leads, notes et textes apparaissent ici dès qu'un lot se termine.",
    EN: "New leads, ratings, and copy land here as soon as a batch finishes.",
  },
  agentWorking: {
    FR: "L'agent travaille",
    EN: "Agent at work",
  },
  recentBatches: {
    FR: "Lots récents",
    EN: "Recent batches",
  },
  leadSingular: { FR: "lead", EN: "lead" },
  leadPlural: { FR: "leads", EN: "leads" },
  waitingOnBalance: { FR: "en attente de solde", EN: "waiting on balance" },
  waitingOnRelease: {
    FR: "en attente de facturation",
    EN: "waiting to be billed",
  },
  releaseHelp: {
    FR: "Votre solde et votre budget hebdomadaire couvrent ces leads : ils sont facturés et livrés dès que la campagne reprend.",
    EN: "Your balance and weekly budget cover these leads: they are billed and delivered as soon as the campaign resumes.",
  },
  waitingOnWeeklyBudget: {
    FR: "en attente du budget hebdomadaire",
    EN: "waiting on weekly budget",
  },
  weeklyBudgetHelp: {
    FR: "Le budget hebdomadaire de cette campagne est atteint : les leads nouvellement découverts sont mis en réserve jusqu'à la réinitialisation la semaine prochaine ou jusqu'à ce que vous augmentiez le budget hebdomadaire. L'agent reste en pause d'ici là.",
    EN: "This campaign's weekly budget is used up, so newly discovered leads are buffered until it resets next week or you raise the weekly budget. The agent stays paused until then.",
  },
  bufferedHelp: {
    FR: "Votre portefeuille est vide : les leads nouvellement découverts sont mis en réserve au lieu d'être livrés. Rechargez pour débloquer les coordonnées et reprendre la livraison ; l'agent reste en pause tant que le solde n'est pas crédité.",
    EN: "Your wallet is empty, so newly discovered leads are buffered instead of being delivered. Top up to unlock contact details and resume delivery; the agent stays paused until balance is credited.",
  },
  topUp: { FR: "Recharger", EN: "Top up" },
  targetReached: {
    FR: "Objectif de {n} leads atteint",
    EN: "Target of {n} leads reached",
  },
  targetReachedHelp: {
    FR: "Cette campagne a produit tous les leads demandés : les {count} leads découverts depuis sont mis en réserve. Augmentez l'objectif (ou passez en volume hebdomadaire ou maximum) pour les débloquer et relancer l'agent.",
    EN: "This campaign produced every lead it was asked for, so the {count} leads discovered since are held in reserve. Raise the target (or switch to weekly or maximum volume) to release them and resume the agent.",
  },
  targetReachedHelpEmpty: {
    FR: "Cette campagne a produit tous les leads demandés. L'agent reste en pause tant que l'objectif n'est pas augmenté ou le mode de volume changé.",
    EN: "This campaign produced every lead it was asked for. The agent stays paused until the target is raised or the volume mode changed.",
  },
  raiseTarget: { FR: "Augmenter l'objectif", EN: "Raise the target" },
  demoReadOnly: {
    FR: "Campagne de démonstration : consultation uniquement.",
    EN: "Demo campaign: browsing only.",
  },
  sampleCapReached: {
    FR: "Plafond de l'échantillon atteint",
    EN: "Sample budget reached",
  },
  sampleConvertHelp: {
    FR: "Cette campagne d'essai a atteint son plafond gratuit : les nouveaux leads sont mis en réserve. Convertissez-la en campagne réelle pour débloquer les {count} leads en réserve et reprendre l'agent (coût : {required} crédits).",
    EN: "This sample campaign has reached its free budget, so new leads are held in reserve. Convert it to a real campaign to release the {count} reserved leads and resume the agent (cost: {required} credits).",
  },
  sampleConvertInsufficient: {
    FR: "Solde insuffisant : {required} crédits sont nécessaires pour débloquer les {count} leads en réserve. Rechargez pour convertir cette campagne.",
    EN: "Insufficient balance: {required} credits are needed to release the {count} reserved leads. Top up to convert this campaign.",
  },
  convertToReal: {
    FR: "Convertir en campagne réelle",
    EN: "Convert to real campaign",
  },
  campaignConverted: {
    FR: "Campagne convertie : les leads en réserve ont été débloqués.",
    EN: "Campaign converted: reserved leads have been released.",
  },
  creditsWord: { FR: "crédits", EN: "credits" },
  balance: { FR: "Solde", EN: "Balance" },
  left: { FR: "restant", EN: "left" },
  spentThisWeek: { FR: "Dépensé cette semaine", EN: "Spent this week" },
  thisWeek: { FR: "cette semaine", EN: "this week" },
  noWeeklyBudgetSet: {
    FR: "aucun budget hebdomadaire défini",
    EN: "no weekly budget set",
  },
  pendingPipeline: { FR: "Pipeline en attente", EN: "Pending pipeline" },
  reservedAmount: { FR: "{amount} réservés", EN: "{amount} reserved" },
  awaitingDelivery: { FR: "en attente de livraison", EN: "awaiting delivery" },
  delivered: { FR: "Livrés", EN: "Delivered" },
  leadsShippedSoFar: {
    FR: "leads livrés à ce jour",
    EN: "leads shipped so far",
  },
  costCampaign: { FR: "Coût (campagne)", EN: "Cost (campaign)" },
  aggregatedAcross: { FR: "Agrégé sur", EN: "Aggregated across" },
  tickSingular: { FR: "tick", EN: "tick" },
  tickPlural: { FR: "ticks", EN: "ticks" },

  // ── Results debrief ──
  digestGreeting: {
    FR: "Bonne nouvelle, on a du neuf pour vous",
    EN: "Good news, we have something new for you",
  },
  digestHeadlineOne: {
    FR: "nouveau prospect trouvé depuis votre dernière visite",
    EN: "new lead found since your last visit",
  },
  digestHeadlineMany: {
    FR: "nouveaux prospects trouvés depuis votre dernière visite",
    EN: "new leads found since your last visit",
  },
  digestFirstVisit: {
    FR: "Voici ce que votre assistant a préparé pendant votre absence.",
    EN: "Here is what your assistant put together while you were away.",
  },
  digestStatTimeSaved: { FR: "Temps économisé", EN: "Time saved" },
  digestStatActions: { FR: "Actions effectuées", EN: "Actions taken" },
  digestEffortOver: { FR: "sur", EN: "across" },
  digestStatEmail: { FR: "Avec e-mail", EN: "With email" },
  digestStatPhone: { FR: "Avec téléphone", EN: "With phone" },
  digestStatWebsite: { FR: "Avec site web", EN: "With website" },
  digestReachTitle: { FR: "Joignabilité", EN: "Reachability" },
  digestEstimateHelp: {
    FR: "Temps économisé estimé à partir du travail manuel équivalent : ouvrir chaque site, le qualifier ou l'écarter, puis relever les coordonnées des sites retenus.",
    EN: "Time saved is estimated from the equivalent manual work: opening each site, qualifying or ruling it out, then collecting the contact details of the ones kept.",
  },
  digestReachHelp: {
    FR: "Chaque prospect est prêt à être contacté dès maintenant.",
    EN: "Every lead is ready to be contacted right away.",
  },
  digestWatcherTitle: { FR: "Veille des registres", EN: "Registry watch" },
  digestWatcherDetected: {
    FR: "{n} événements détectés dans votre zone",
    EN: "{n} events detected in your area",
  },
  digestWatcherDetectedOne: {
    FR: "1 événement détecté dans votre zone",
    EN: "1 event detected in your area",
  },
  digestWatcherCreation: { FR: "Créations", EN: "New establishments" },
  digestWatcherReprise: { FR: "Reprises", EN: "Takeovers" },
  digestWatcherMiseEnActivite: {
    FR: "Mises en activité",
    EN: "Activity starts",
  },
  digestWatcherUpcoming: {
    FR: "{n} pas encore ouverts",
    EN: "{n} not open yet",
  },
  digestWatcherUpcomingHint: {
    FR: "Nous recherchons leur fiche Google à l'approche de l'ouverture et complétons le lead dès qu'elle apparaît.",
    EN: "We look their Google listing up again as they open, and complete the lead as soon as it appears.",
  },
  digestWatcherQueued: {
    FR: "{n} en cours de traitement",
    EN: "{n} being processed",
  },
  digestWatcherSkipped: { FR: "Écartés :", EN: "Set aside:" },
  digestWatcherSkipNoContact: { FR: "sans contact", EN: "no contact" },
  digestWatcherSkipDuplicate: { FR: "doublons", EN: "duplicates" },
  digestWatcherSkipStale: { FR: "trop anciens", EN: "too old" },
  digestWatcherSkipOutOfZone: { FR: "hors zone", EN: "out of area" },
  digestWatcherSkipOther: { FR: "autres", EN: "other" },
  digestSessionsOne: { FR: "session", EN: "session" },
  digestSessionsMany: { FR: "sessions", EN: "sessions" },
  digestKeyboardHint: { FR: "Naviguez avec", EN: "Navigate with" },
  digestBrowse: {
    FR: "Voir les prospects un par un",
    EN: "Review leads one by one",
  },
  // Closing lands on the campaign page the dialog opened over, so the label
  // names that destination rather than the act of dismissing.
  digestSkip: { FR: "Accéder à ma campagne", EN: "Go to my campaign" },
  digestBack: { FR: "Retour au récapitulatif", EN: "Back to the recap" },
  digestPrevious: { FR: "Précédent", EN: "Previous" },
  digestNext: { FR: "Suivant", EN: "Next" },
  digestFinish: { FR: "Terminer", EN: "Done" },
  digestCounter: { FR: "sur", EN: "of" },
  digestReplay: { FR: "Revoir le récapitulatif", EN: "Replay the recap" },
  digestSeconds: { FR: "s", EN: "s" },
  digestMinutes: { FR: "min", EN: "min" },
  digestHours: { FR: "h", EN: "h" },
  digestDays: { FR: "j", EN: "d" },
  digestLeadScore: { FR: "Site noté", EN: "Site scored" },
  digestLeadTopAngles: { FR: "Meilleurs angles", EN: "Top angles" },
  digestLeadMoreAngles: { FR: "+{n} autres angles", EN: "+{n} more angles" },
  digestLeadContacts: { FR: "Contacts trouvés", EN: "Contacts found" },
  digestLeadMoreContacts: {
    FR: "+{n} autres contacts sur la fiche",
    EN: "+{n} more contacts on the lead",
  },
  digestLeadNoContacts: {
    FR: "Aucun contact pour l'instant : l'enrichissement tourne toujours.",
    EN: "No contact yet: enrichment is still running.",
  },
  digestLeadGeneric: { FR: "Contact général", EN: "General contact" },
  digestLeadNoWebsite: { FR: "Pas de site web", EN: "No website" },
  digestLeadNoPreview: {
    FR: "Pas de site web",
    EN: "No website",
  },
  // Shown when the business does have a site the frame cannot load: an http
  // page cannot be embedded in an https one. Saying "no website" there is a
  // lie the user can check against the link right below it.
  digestLeadPreviewBlocked: {
    FR: "Aperçu indisponible pour ce site",
    EN: "Preview unavailable for this site",
  },
  digestLeadReviews: { FR: "({n} avis)", EN: "({n} reviews)" },
  digestLeadAds: { FR: "Paye de la publicité", EN: "Pays for ads" },
  digestLeadHiring: {
    FR: "{n} {n|poste ouvert|postes ouverts}",
    EN: "{n} open {n|role|roles}",
  },
  digestLeadRanTitle: {
    FR: "Enrichissements effectués",
    EN: "Enrichments run",
  },
  digestLeadRanContacts: { FR: "Contacts", EN: "Contacts" },
  digestLeadRanPeople: { FR: "Décideurs", EN: "Decision makers" },
  digestLeadRanSocials: { FR: "Réseaux sociaux", EN: "Socials" },
  digestLeadRanRatings: { FR: "Avis clients", EN: "Reviews" },
  digestLeadRanAds: { FR: "Publicité", EN: "Ads" },
  digestLeadRanJobOffers: { FR: "Offres d'emploi", EN: "Job offers" },
  digestLeadRanAudit: { FR: "Audit du site", EN: "Website audit" },
  digestLeadRanCustom: { FR: "Recherche personnalisée", EN: "Custom research" },
  digestLeadRanMailing: { FR: "Copie e-mail", EN: "Email copy" },
} satisfies FullTranslation

export const CAMPAIGN_CHARTS_T = {
  reservedLabel: { FR: "Réservés", EN: "Reserved" },
  deliveredLabel: { FR: "Livrés", EN: "Delivered" },
  usageLabel: { FR: "Consommation", EN: "Usage" },
  leadsLabel: { FR: "Leads", EN: "Leads" },
  leadsPerDay: { FR: "Leads par jour", EN: "Leads per day" },
  leadsPerDayDesc: {
    FR: "Réservés vs livrés, sur les {days} derniers jours.",
    EN: "Reserved vs delivered, last {days} days.",
  },
  leadsPerDayDescSolo: {
    FR: "Prospects livrés, sur les {days} derniers jours.",
    EN: "Leads delivered, over the last {days} days.",
  },
  noCoverage: {
    FR: "Aucun prospect à mesurer pour l'instant.",
    EN: "No lead to measure yet.",
  },
  usagePerDay: { FR: "Consommation par jour", EN: "Usage per day" },
  usagePerDayDesc: {
    FR: "Facturée à la collecte, sur les {days} derniers jours (crédits).",
    EN: "Charged at intake, last {days} days (credits).",
  },
  contactCoverage: {
    FR: "Couverture des contacts",
    EN: "Contact coverage",
  },
  contactCoverageDesc: {
    FR: "Combien de leads disposent d'un email, d'un téléphone, des deux ou d'aucun.",
    EN: "How many leads carry email, phone, both, or neither.",
  },
  emailPlusPhone: { FR: "Email + téléphone", EN: "Email + phone" },
  emailOnly: { FR: "Email uniquement", EN: "Email only" },
  phoneOnly: { FR: "Téléphone uniquement", EN: "Phone only" },
  neither: { FR: "Aucun", EN: "Neither" },
  noData: {
    FR: "Aucune donnée sur les {days} derniers jours pour l'instant.",
    EN: "No data in the last {days} days yet.",
  },
  noDataYoung: {
    FR: "Campagne lancée il y a {days} {days|jour|jours} : les premiers résultats arrivent.",
    EN: "Campaign launched {days} {days|day|days} ago: the first results are on their way.",
  },
} satisfies FullTranslation

export const NO_PLAN_BANNER_T = {
  title: {
    FR: "Cette campagne est prête, mais en pause",
    EN: "This campaign is ready, but paused",
  },
  description: {
    FR: "Elle démarre dès que vous choisissez une offre : rien à reconfigurer, vos réglages sont enregistrés.",
    EN: "It starts the moment you pick a plan: nothing to set up again, your settings are saved.",
  },
  cta: { FR: "Voir les offres", EN: "See plans" },
} satisfies FullTranslation

export const CAMPAIGN_ACTIONS_T = {
  downloadLabel: { FR: "Télécharger", EN: "Download" },
  downloadMenuLabel: {
    FR: "Format d'export",
    EN: "Export format",
  },
  downloadJson: { FR: "JSON", EN: "JSON" },
  downloadCsv: { FR: "CSV", EN: "CSV" },
  downloadExcel: { FR: "Excel", EN: "Excel" },
  downloadSettings: {
    FR: "Colonnes et contacts…",
    EN: "Columns and contacts…",
  },
  downloadError: {
    FR: "Le téléchargement a échoué",
    EN: "The download failed",
  },
  downloadAll: {
    FR: "Télécharger tous les prospects",
    EN: "Download every lead",
  },
  magicLinkCopied: { FR: "Lien magique copié", EN: "Magic link copied" },
  copyFailed: { FR: "Échec de la copie", EN: "Copy failed" },
  share: { FR: "Partager", EN: "Share" },
  resume: { FR: "Reprendre", EN: "Resume" },
  pause: { FR: "Mettre en pause", EN: "Pause" },
  campaignResumed: { FR: "Campagne relancée", EN: "Campaign resumed" },
  campaignStillBudgetPaused: {
    FR: "Le budget hebdomadaire est atteint : la campagne reprendra quand il se libère, ou augmentez le volume hebdomadaire.",
    EN: "The weekly budget is used up: the campaign resumes once it frees, or raise the weekly volume.",
  },
  campaignPaused: { FR: "Campagne mise en pause", EN: "Campaign paused" },
  toastDeleted: { FR: "Campagne supprimée", EN: "Campaign deleted" },
  delete: { FR: "Supprimer", EN: "Delete" },
  deleteTitle: {
    FR: "Supprimer cette campagne ?",
    EN: "Delete this campaign?",
  },
  deleteDescription: {
    FR: "et tous les enregistrements de leads livrés associés seront supprimés. Le pipeline en attente (leads non encore livrés) est également supprimé. Cette action est irréversible.",
    EN: "and all associated delivered lead records will be removed. The pending pipeline (leads not yet delivered) is also dropped. This cannot be undone.",
  },
  cancel: { FR: "Annuler", EN: "Cancel" },
  deleting: { FR: "Suppression…", EN: "Deleting…" },
  deleteCampaign: { FR: "Supprimer la campagne", EN: "Delete campaign" },
  setDemo: { FR: "Marquer comme démo", EN: "Mark as demo" },
  unsetDemo: { FR: "Retirer la démo", EN: "Unmark demo" },
  demoSet: { FR: "Campagne marquée démo", EN: "Campaign marked as demo" },
  demoUnset: { FR: "Démo retirée", EN: "Demo flag removed" },
} satisfies FullTranslation

export const EXHAUSTED_BANNER_T = {
  title: {
    FR: "Toutes les sous-campagnes sont épuisées",
    EN: "All sub-campaigns are exhausted",
  },
  description: {
    FR: "Toutes les combinaisons de mots-clés et de lieux ont été explorées. Ajoutez de nouveaux mots-clés ou lieux pour que cette campagne continue à découvrir des leads.",
    EN: "Every keyword and place combination has been scoured. Add new keywords or places to keep this campaign discovering leads.",
  },
  cta: {
    FR: "Ajouter des mots-clés ou des lieux",
    EN: "Add keywords or places",
  },
  watcherTitle: {
    FR: "Tous les événements récents ont été traités",
    EN: "Every recent event has been processed",
  },
  watcherDescription: {
    FR: "La campagne se relance seule dès qu'une nouvelle création ou reprise correspond à votre zone et à vos activités. Élargissez-les pour en recevoir davantage.",
    EN: "The campaign wakes up on its own as soon as a new opening or takeover matches your area and activities. Widen them to receive more.",
  },
  watcherCta: {
    FR: "Modifier la zone ou les activités",
    EN: "Edit area or activities",
  },
} satisfies FullTranslation

export const LEADS_MAP_T = {
  noGeoLeads: {
    FR: "Aucun lead géolocalisé pour l'instant.",
    EN: "No geolocated leads yet.",
  },
  geoHelp: {
    FR: "Les adresses sont géocodées en arrière-plan après le scraping. Réessayez dans quelques minutes.",
    EN: "Addresses are geocoded in the background after scraping. Try again in a few minutes.",
  },
  notGeocodedOne: {
    FR: "{n} lead pas encore géocodé.",
    EN: "{n} lead not yet geocoded.",
  },
  notGeocodedMany: {
    FR: "{n} leads pas encore géocodés.",
    EN: "{n} leads not yet geocoded.",
  },
  unknown: { FR: "Inconnu", EN: "Unknown" },
  reviews: { FR: "avis", EN: "reviews" },
  address: { FR: "Adresse", EN: "Address" },
  website: { FR: "Site web", EN: "Website" },
  email: { FR: "Email", EN: "Email" },
  phone: { FR: "Téléphone", EN: "Phone" },
} satisfies FullTranslation

export const LEADS_PANE_T = {
  loadingMap: { FR: "Chargement de la carte...", EN: "Loading map..." },
  todoTitle: { FR: "À faire", EN: "To do" },
  todoOverdue: {
    FR: "{n} {n|en retard|en retard}",
    EN: "{n} overdue",
  },
  todoToday: {
    FR: "{n} pour aujourd'hui",
    EN: "{n} due today",
  },
  todoReplies: {
    FR: "{n} {n|réponse|réponses} à lire",
    EN: "{n} {n|reply|replies} to read",
  },
  todoShowAll: { FR: "Tout afficher", EN: "Show all" },
  statusBuffered: { FR: "En réserve", EN: "Buffered" },
  statusBufferedHint: {
    FR: "Ce lead a été trouvé mais pas encore livré : ses coordonnées restent masquées jusqu'à ce que votre solde couvre son coût.",
    EN: "This lead was found but not delivered yet: its contact details stay hidden until your balance covers its cost.",
  },
  coverageLabel: { FR: "Zones couvertes", EN: "Targets covered" },
  opportunityThemeCompliance: { FR: "RGPD", EN: "GDPR" },
  opportunityThemeVisibilityAi: {
    FR: "Visibilité IA",
    EN: "AI visibility",
  },
  opportunityGeoBuyerQuestions: {
    FR: "Ce que demandent ses clients",
    EN: "What its customers ask",
  },
  opportunityGeoPracticeQuestions: {
    FR: "Bonnes pratiques du métier",
    EN: "Trade best practices",
  },
  opportunityGeoAbsent: { FR: "absente", EN: "absent" },
  opportunityPitchObjections: {
    FR: "Ce qu'ils vont objecter",
    EN: "What they will push back on",
  },
  opportunityGeoCitedAt: {
    FR: "Citée en position {n}",
    EN: "Cited at position {n}",
  },
  opportunityGeoAbsentStatus: {
    FR: "Absente des réponses de l'IA",
    EN: "Not in the AI's answers",
  },
  opportunityGeoSourcesLabel: {
    FR: "Sites cités par l'IA, dans l'ordre",
    EN: "Sites the AI cites, in order",
  },
  opportunityGeoOwnSite: { FR: "cette entreprise", EN: "this business" },
  opportunityGeoMoreSources: {
    FR: "+{n} {n|autre site|autres sites}",
    EN: "+{n} more {n|site|sites}",
  },
  opportunityKeywordReasonHint: {
    FR: "Pourquoi ce mot-clé compte pour ce métier",
    EN: "Why this keyword matters for this trade",
  },
  leadsShown: {
    FR: "{shown} {shown|lead affiché|leads affichés} sur {total}",
    EN: "{shown} of {total} leads shown",
  },
  listView: { FR: "Vue liste", EN: "List view" },
  list: { FR: "Liste", EN: "List" },
  mapView: { FR: "Vue carte", EN: "Map view" },
  map: { FR: "Carte", EN: "Map" },
  searchPlaceholder: {
    FR: "Nom, domaine, adresse...",
    EN: "Name, domain, address...",
  },
  reset: { FR: "Réinitialiser", EN: "Reset" },
  viewModeLabel: { FR: "Affichage", EN: "View" },
  filterChip: { FR: "{group} : {value}", EN: "{group}: {value}" },
  searchChip: { FR: "Recherche : « {q} »", EN: "Search: “{q}”" },
  removeFilter: { FR: "Retirer {label}", EN: "Remove {label}" },
  filters: { FR: "Filtres", EN: "Filters" },
  filterLeads: { FR: "Filtrer les leads", EN: "Filter leads" },
  narrowList: {
    FR: "Combinez les critères, la liste se met à jour en direct.",
    EN: "Combine criteria, the list updates as you go.",
  },
  clearFilter: { FR: "Effacer", EN: "Clear" },
  showLeads: { FR: "Voir {n} leads", EN: "Show {n} leads" },
  contactData: { FR: "Coordonnées", EN: "Contact data" },
  anyContact: { FR: "Tous", EN: "All" },
  withEmail: { FR: "Email", EN: "Email" },
  withPhone: { FR: "Téléphone", EN: "Phone" },
  withEmailOrPhone: {
    FR: "Email ou tél.",
    EN: "Email or phone",
  },
  withEmailAndPhone: {
    FR: "Email et tél.",
    EN: "Email and phone",
  },
  websiteQuality: { FR: "Qualité du site web", EN: "Website quality" },
  anyQuality: { FR: "Toutes", EN: "All" },
  qualityHigh: { FR: "Élevée (75-100)", EN: "High (75-100)" },
  qualityMedium: { FR: "Moyenne (40-74)", EN: "Medium (40-74)" },
  qualityLow: { FR: "Faible (0-39)", EN: "Low (0-39)" },
  qualityUnrated: { FR: "Non évalué", EN: "Unrated" },
  minimumRating: { FR: "Note minimale", EN: "Minimum rating" },
  anyRating: { FR: "Toutes", EN: "All" },
  minimumReviews: { FR: "Nombre d'avis minimal", EN: "Minimum reviews" },
  anyReviewCount: { FR: "Tous", EN: "All" },
  paidAds: { FR: "Publicités payantes", EN: "Paid ads" },
  anyAds: { FR: "Tous", EN: "All" },
  payingForAds: { FR: "Avec pub", EN: "Running ads" },
  noPaidAds: { FR: "Sans pub", EN: "No ads" },
  leadsOf: { FR: "{shown} sur {total} leads", EN: "{shown} of {total} leads" },
  resetAll: { FR: "Tout réinitialiser", EN: "Reset all" },
  noLeadYet: {
    FR: "Aucun lead pour l'instant.",
    EN: "No leads yet.",
  },
  noLeadMatches: {
    FR: "Aucun lead ne correspond aux filtres actuels.",
    EN: "No lead matches the current filters.",
  },
  customAnswerLabel: { FR: "Demande personnalisée", EN: "Custom request" },
  customAnswerAny: { FR: "Tous", EN: "All" },
  customAnswerYes: { FR: "Oui", EN: "Yes" },
  customAnswerNo: { FR: "Non", EN: "No" },
  customAnswerNone: { FR: "Sans réponse", EN: "No answer" },
  bulkToolbarLabel: {
    FR: "Actions sur la sélection",
    EN: "Selection actions",
  },
  bulkAllSelected: {
    FR: "Tous les leads affichés sont sélectionnés",
    EN: "Every shown lead is selected",
  },
  bulkSelected: {
    FR: "{n} sur {total} {n|sélectionné|sélectionnés}",
    EN: "{n} of {total} selected",
  },
  targetsTitle: { FR: "Zones", EN: "Targets" },
  targetsCovered: {
    FR: "{done} / {total} {done|couverte|couvertes}",
    EN: "{done} / {total} covered",
  },
  targetsOpen: {
    FR: "Voir les zones, {done} sur {total} {done|couverte|couvertes}",
    EN: "Show targets, {done} of {total} covered",
  },
  targetInProgress: { FR: "En cours", EN: "In progress" },
  targetPausedHere: { FR: "En pause ici", EN: "Paused here" },
  targetNext: { FR: "À suivre", EN: "Next" },
  targetCoveredSr: { FR: "Couverte", EN: "Covered" },
  targetsCoveredEarlier: {
    FR: "+ {n} {n|couverte|couvertes} plus tôt",
    EN: "+ {n} covered earlier",
  },
  targetsMoreUpcoming: { FR: "+ {n} à venir", EN: "+ {n} more to come" },
  targetsAllCovered: {
    FR: "Toutes les zones sont couvertes.",
    EN: "Every target is covered.",
  },
  targetsEmpty: {
    FR: "Aucune zone pour cette campagne.",
    EN: "No target for this campaign.",
  },
  targetsError: {
    FR: "Impossible de charger les zones.",
    EN: "Could not load the targets.",
  },
  targetsRetry: { FR: "Réessayer", EN: "Retry" },
  targetResultsOne: { FR: "{n} résultat", EN: "{n} result" },
  targetResultsMany: { FR: "{n} résultats", EN: "{n} results" },
  creditWord: { FR: "crédit", EN: "credit" },
  creditsWord: { FR: "crédits", EN: "credits" },
  leadNumber: { FR: "Lead n°{id}", EN: "Lead #{id}" },
  enriching: { FR: "Enrichissement", EN: "Enriching" },
  notSynced: { FR: "Non synchronisé", EN: "Not synced" },
  notSyncedHint: {
    FR: "En attente d'un envoi manuel (synchronisation automatique désactivée, ou lead hors des extractions de la campagne) : cochez-le puis Actions > Synchroniser pour l'envoyer.",
    EN: "Waiting for a manual sync (auto-sync is off, or the lead is outside the campaign's extractions): tick it, then Actions > Sync to send it.",
  },
  syncFilterLabel: { FR: "Synchronisation", EN: "Sync" },
  syncFilterAll: { FR: "Tous", EN: "All" },
  syncFilterHeld: { FR: "Non synchronisés", EN: "Not synced" },
  syncAction: { FR: "Synchroniser", EN: "Sync" },
  syncActionHint: {
    FR: "Cochez des leads non synchronisés pour les envoyer.",
    EN: "Tick leads that are not synced to send them.",
  },
  syncedToast: {
    FR: "{n} {n|lead synchronisé|leads synchronisés}",
    EN: "{n} {n|lead|leads} synced",
  },
  batchBadge: { FR: "Lot {n}", EN: "Batch {n}" },
  batchBadgeHint: {
    FR: "{nth} extraction de cette campagne",
    EN: "Campaign's {nth} extraction",
  },
  batchStartedAt: { FR: "Extrait le {date}", EN: "Extracted on {date}" },
  batchCost: {
    FR: "Coût : {n} {count|crédit|crédits}",
    EN: "Cost: {n} {count|credit|credits}",
  },
  deliveredOn: { FR: "Livré le {date}", EN: "Delivered on {date}" },
  ratingSites: { FR: "· {n} sites", EN: "· {n} sites" },
  ratingNoReviews: { FR: "0 avis", EN: "0 reviews" },
  presenceToggle: { FR: "Présence en ligne", EN: "Online presence" },
  presenceRatings: { FR: "Avis", EN: "Reviews" },
  presenceAds: { FR: "Publicité", EN: "Advertising" },
  presenceSocials: { FR: "Réseaux sociaux", EN: "Social profiles" },
  presenceRatingFallback: { FR: "Note", EN: "Rating" },
  importBadge: { FR: "Import", EN: "Import" },
  importBadgeHint: {
    FR: "Lead importé, hors extraction automatique.",
    EN: "Imported lead, not from an automatic extraction.",
  },
  enrichingHint: {
    FR: "Enrichissement en cours : contacts, notes et signaux continuent d'arriver.",
    EN: "Enrichment in progress: contacts, ratings and signals are still landing.",
  },
  fairProofLink: { FR: "exposants", EN: "exhibitors" },
  jobListingLink: { FR: "offre d'emploi", EN: "job listing" },
  adRegistryActive: { FR: "Pub en cours", EN: "Running ads" },
  adRegistryActiveSeen: {
    FR: "Pub en cours, vue le {date}",
    EN: "Running ads, seen on {date}",
  },
  adRegistryPast: { FR: "Dernière pub le {date}", EN: "Last ad on {date}" },
  adRegistryPastUndated: {
    FR: "A fait de la pub, plus maintenant",
    EN: "Advertised before, not now",
  },
  adRegistryNone: { FR: "Aucune pub trouvée", EN: "No ads found" },
  socialsNoneFoundLine: {
    FR: "Aucun réseau trouvé",
    EN: "No network found",
  },
  adRegistryUnchecked: { FR: "Non vérifié", EN: "Not checked" },
  adRegistryUnreachable: {
    FR: "Non vérifié : registre inaccessible",
    EN: "Not checked: registry unreachable",
  },
  adRegistryNoCity: {
    FR: "Non vérifié : la campagne ne cible pas de ville",
    EN: "Not checked: the campaign targets no city",
  },
  staffBadge: { FR: "Staff", EN: "Staff" },
  staffOnlyHint: {
    FR: "Visible uniquement par le staff : le client ne voit pas cette information.",
    EN: "Staff only: the customer does not see this.",
  },
  unknown: { FR: "Inconnu", EN: "Unknown" },
  hunterDecisionMaker: {
    FR: "Décideur avec email professionnel vérifié",
    EN: "Decision maker with a verified professional email",
  },
  websearchDecisionMaker: {
    FR: "Identifié par recherche web",
    EN: "Identified by web search",
  },
  pappersDecisionMaker: {
    FR: "Dirigeant nommé au registre des entreprises",
    EN: "Officer named in the company registry",
  },
  contactDecisionMaker: {
    FR: "Contact trouvé sur le site de l'entreprise",
    EN: "Contact found on the company's own site",
  },
  linkedinProfile: { FR: "Profil LinkedIn", EN: "LinkedIn profile" },
  peopleHeading: { FR: "Contacts", EN: "Contacts" },
  tasksHeading: { FR: "Tâches", EN: "Tasks" },
  phoneRoster: { FR: "Téléphones", EN: "Phone numbers" },
  outreachUnranked: { FR: "Non contacté", EN: "Not contacted" },
  outreachUnrankedTip: {
    FR: "L'agent ne le contactera pas : aucun canal utilisé par la séquence n'est renseigné pour ce contact.",
    EN: "The agent will not contact them: none of the channels the sequence uses is filled in for this contact.",
  },
  outreachRankTip: {
    FR: "Contacté en {rank} position par l'agent, sur {total}",
    EN: "Contacted {rank} of {total} by the agent",
  },
  peopleShowMore: {
    FR: "Voir {n} {n|contact|contacts} de plus",
    EN: "Show {n} more {n|contact|contacts}",
  },
  peopleShowLess: { FR: "Voir moins", EN: "Show less" },
  phonesShowMore: {
    FR: "Voir {n} {n|numéro|numéros} de plus",
    EN: "Show {n} more {n|number|numbers}",
  },
  contactAdd: { FR: "Ajouter un contact", EN: "Add a contact" },
  contactEdit: { FR: "Modifier le contact", EN: "Edit contact" },
  contactDelete: { FR: "Supprimer le contact", EN: "Delete contact" },
  contactDeleteConfirm: {
    FR: "Supprimer ce contact du lead ? Il ne sera plus exporté ni prospecté.",
    EN: "Remove this contact from the lead? It will no longer be exported or prospected.",
  },
  contactDeleted: { FR: "Contact supprimé", EN: "Contact removed" },
  contactSaved: { FR: "Contact enregistré", EN: "Contact saved" },
  contactCreated: { FR: "Contact ajouté", EN: "Contact added" },
  contactName: { FR: "Nom", EN: "Name" },
  contactRole: { FR: "Fonction", EN: "Role" },
  contactEmails: { FR: "E-mails", EN: "Emails" },
  contactPhones: { FR: "Téléphones", EN: "Phones" },
  contactLinkedin: { FR: "Profil LinkedIn", EN: "LinkedIn profile" },
  contactEditedBadge: { FR: "modifié", EN: "edited" },
  contactManualBadge: { FR: "ajouté", EN: "added" },
  contactEditedHint: {
    FR: "Contact modifié à la main : l'enrichissement ne l'écrasera plus",
    EN: "Hand-edited contact: enrichment will no longer overwrite it",
  },
  contactManualHint: {
    FR: "Contact ajouté à la main, il ne vient pas de la collecte",
    EN: "Hand-written contact: it does not come from the scrape",
  },
  contactCancel: { FR: "Annuler", EN: "Cancel" },
  contactSave: { FR: "Enregistrer", EN: "Save" },
  contactAddShort: { FR: "Ajouter", EN: "Add" },
  contactAddPhone: { FR: "Ajouter un numéro", EN: "Add a number" },
  contactAddEmail: { FR: "Ajouter un e-mail", EN: "Add an email" },
  contactRemoveValue: { FR: "Retirer", EN: "Remove" },
  contactsEmpty: { FR: "Aucun contact", EN: "No contact yet" },
  phonesEmpty: { FR: "Aucun numéro", EN: "No number yet" },
  contactAddDescription: {
    FR: "Ajouté à la main : l'enrichissement ne l'écrasera pas.",
    EN: "Added by hand: enrichment will not overwrite it.",
  },
  contactEditDescription: {
    FR: "Une fois modifié, l'enrichissement n'écrasera plus ce contact.",
    EN: "Once edited, enrichment no longer overwrites this contact.",
  },
  contactPhoneDescription: {
    FR: "Le nom et la fonction servent d'étiquette au numéro (ex. Accueil).",
    EN: "The name and role label the number (e.g. Front desk).",
  },
  contactPhoneLabel: { FR: "Étiquette", EN: "Label" },
  contactLinkedinPlaceholder: {
    FR: "https://www.linkedin.com/in/…",
    EN: "https://www.linkedin.com/in/…",
  },
  contactErrorEmpty: {
    FR: "Renseignez au moins un nom, un e-mail ou un numéro.",
    EN: "Fill in at least a name, an email or a number.",
  },
  contactErrorEmail: {
    FR: "Adresse e-mail invalide.",
    EN: "Invalid email address.",
  },
  contactErrorPhone: {
    FR: "Numéro invalide pour ce pays.",
    EN: "Invalid number for this country.",
  },
  contactErrorLinkedin: {
    FR: "Lien invalide : il doit commencer par https://",
    EN: "Invalid link: it must start with https://",
  },
  opportunityTitle: {
    FR: "Audit du site web",
    EN: "Website audit",
  },
  jobOffersTitle: {
    FR: "Offres d'emploi",
    EN: "Job offers",
  },
  jobOffersCount: {
    FR: "{n} postes ouverts",
    EN: "{n} open roles",
  },
  jobOffersCountOne: {
    FR: "1 poste ouvert",
    EN: "1 open role",
  },
  jobOffersNone: {
    FR: "aucun poste ouvert",
    EN: "no open roles",
  },
  jobOffersNoneHelp: {
    FR: "Aucune offre ouverte trouvée pour cette entreprise au moment de la vérification.",
    EN: "No open offer found for this business at the time of the check.",
  },
  jobOffersSourcesChecked: {
    FR: "Sources vérifiées :",
    EN: "Sources checked:",
  },
  jobOffersSourceWebsite: { FR: "Site web", EN: "Website" },
  jobOffersSourceOther: { FR: "Autres", EN: "Other" },
  jobOffersShowMore: {
    FR: "+{n} {n|autre offre|autres offres}",
    EN: "+{n} more {n|offer|offers}",
  },
  // Neutral wording: the list mixes buying signals with gaps, and both are
  // reasons to work this lead.
  // "signal" pluralises to "signaux" in French, so the "(s)" shorthand used
  // elsewhere in this file cannot carry it: each count gets its own singular
  // and plural string.
  opportunityThemeCount: { FR: "{n} thèmes", EN: "{n} themes" },
  opportunityThemeCountOne: { FR: "1 thème", EN: "1 theme" },
  opportunitySignalCount: { FR: "{n} signaux", EN: "{n} signals" },
  opportunitySignalCountOne: { FR: "1 signal", EN: "1 signal" },
  // Severity as a group heading: red and orange rank the site's problems by
  // urgency. "Positive" only ever holds buying signals, which are not a verdict
  // on the site, so they are named for what they tell the rep.
  opportunitySeverityPositive: { FR: "Peut investir", EN: "Can invest" },
  opportunitySeverityMedium: { FR: "À surveiller", EN: "Worth watching" },
  opportunitySeverityHigh: { FR: "Urgent", EN: "Urgent" },
  opportunityThemeSignalsCount: {
    FR: "{n} {n|signal détecté|signaux détectés}",
    EN: "{n} {n|signal|signals} detected",
  },
  opportunityGeoQuestionHeader: { FR: "Question", EN: "Question" },
  opportunityGeoSourcesHeader: { FR: "Sites cités", EN: "Sites cited" },
  opportunityBuyingSignalsHint: {
    FR: "Ce qui montre que ce prospect a le budget. Du contexte, pas un point fort du site.",
    EN: "What shows this prospect has the budget. Context, not a strength of the site.",
  },
  opportunityThemeMoney: {
    FR: "Signaux d'achat",
    EN: "Buying signals",
  },
  opportunitySpeedLink: {
    FR: "Ouvrir le rapport PageSpeed",
    EN: "Open the PageSpeed report",
  },
  opportunityProfileLink: {
    FR: "Ouvrir la fiche Google",
    EN: "Open the Google profile",
  },
  opportunityThemeGoogleProfile: {
    FR: "Fiche Google",
    EN: "Google profile",
  },
  opportunityThemeVisibilityGeo: {
    FR: "Visibilité géographique",
    EN: "Geographic visibility",
  },
  opportunityThemeVisibilityKeyword: {
    FR: "Visibilité mots-clés",
    EN: "Keyword visibility",
  },
  opportunityThemeSeoTechnical: {
    FR: "Référencement technique",
    EN: "Technical SEO",
  },
  // Rail sections: the visibility axes first, then everything about the site.
  opportunitySectionVisibility: { FR: "Visibilité", EN: "Visibility" },
  opportunitySectionSite: { FR: "Site web", EN: "Website" },
  opportunityCompetitorsLead: {
    FR: "Les assistants recommandent :",
    EN: "The assistants recommend:",
  },
  opportunityThemeConversion: { FR: "Conversion", EN: "Conversion" },
  opportunityThemeSpeed: { FR: "Performance", EN: "Performance" },
  opportunityThemeDesign: {
    FR: "Design & ancienneté",
    EN: "Design & age",
  },
  opportunityThemeAcquisition: { FR: "Acquisition", EN: "Acquisition" },
  opportunityThemeTrust: { FR: "Réassurance", EN: "Trust" },
  opportunityBlocked: {
    FR: "Ce site bloque l'analyse automatique.",
    EN: "This site blocks automated analysis.",
  },
  // What each search table measures. The two are different questions: where the
  // site comes out on a Google search, versus whether the site talks about the
  // subject at all.
  opportunityChecksLabel: {
    FR: "Position sur Google",
    EN: "Position on Google",
  },
  opportunityKeywordSearchHeader: { FR: "Recherche", EN: "Search" },
  opportunityKeywordVolumeHeader: {
    FR: "Volume de recherche",
    EN: "Search volume",
  },
  opportunityKeywordVolumeSummary: {
    FR: "{n} recherches/mois",
    EN: "{n} searches/mo",
  },
  opportunityKeywordPositionHeader: { FR: "Position", EN: "Position" },
  // Distinct from "non listé": the placement has simply not been walked yet.
  // The report is rebuilt three times per lead and the first two run before any
  // SERP was read, so this is what those two builds show.
  opportunityKeywordPositionUnknown: {
    FR: "non mesuré",
    EN: "not measured",
  },
  opportunityRankShort: { FR: "#{n}", EN: "#{n}" },
  opportunityRankPageHeader: { FR: "Page", EN: "Page" },
  opportunityLocalBase: { FR: "sa ville", EN: "own town" },
  opportunityChecksHint: {
    FR: "Positions relevées sur Google.",
    EN: "Positions measured on Google.",
  },
  opportunityRank: {
    FR: "Position Google #{n}",
    EN: "Google position #{n}",
  },
  opportunityRankHint: {
    FR: "Placement relevé le jour de la découverte, sur cette recherche.",
    EN: "Placement measured on the discovery date, for this search.",
  },
  // Not "absent": we measure the organic results only, from a server, on one day.
  // A prospect who sees their Google Business card or an ad on that search would
  // read "absent" as plainly false and stop trusting the rest of the audit.
  opportunityRankCheckAbsent: { FR: "non listé", EN: "not listed" },
  noOwnWebsite: {
    FR: "Pas de site propre (annuaire uniquement)",
    EN: "No own website (directory listing only)",
  },
  googleProfileLink: { FR: "Fiche Google", EN: "Google profile" },
  noWebsiteOpportunityTitle: {
    FR: "Opportunité : aucun site web",
    EN: "Opportunity: no website",
  },
  noWebsiteOpportunityBody: {
    FR: "Cette entreprise n'a pas de site web. Le premier site est l'offre évidente.",
    EN: "This business has no website. A first website is the obvious pitch.",
  },
  gmbPresent: {
    FR: "Seule présence en ligne : sa fiche Google.",
    EN: "Their only online presence: their Google profile.",
  },
  gmbAbsent: {
    FR: "Aucune fiche Google non plus : invisible en ligne.",
    EN: "No Google profile either: invisible online.",
  },
  companyFicheToggle: { FR: "Fiche entreprise", EN: "Company record" },
  // ── Business event (watcher source) ──
  watcherEventCreation: { FR: "Création", EN: "New establishment" },
  watcherEventReprise: { FR: "Reprise", EN: "Takeover" },
  watcherEventMiseEnActivite: {
    FR: "Mise en activité",
    EN: "Activity start",
  },
  watcherEventBadgeHint: {
    FR: "Événement d'entreprise qui a fait remonter ce lead.",
    EN: "The business event that surfaced this lead.",
  },
  watcherUpcomingOn: {
    FR: "Ouverture prévue le {date}",
    EN: "Opening on {date}",
  },
  watcherCreatedOn: { FR: "Créé le {date}", EN: "Created on {date}" },
  watcherTakenOverOn: { FR: "Repris le {date}", EN: "Taken over on {date}" },
  watcherActiveSince: {
    FR: "En activité depuis le {date}",
    EN: "Active since {date}",
  },
  watcherSalePrice: { FR: "Cession : {price}", EN: "Sale: {price}" },
  watcherBodaccLink: { FR: "Annonce BODACC", EN: "BODACC notice" },
  watcherChainSite: {
    FR: "Établissement secondaire",
    EN: "Secondary establishment",
  },
  watcherChainSiteHint: {
    FR: "Le siège de l'entreprise est ailleurs : une chaîne, un groupe ou une holding.",
    EN: "The company's head office is elsewhere: a chain, a group or a holding.",
  },
  watcherLikelyTakeover: { FR: "Reprise probable", EN: "Likely takeover" },
  watcherLikelyTakeoverHint: {
    FR: "Google connaissait déjà cet établissement avant l'événement : une nouvelle société exploite un commerce existant. Vérifiez que les contacts ne sont pas ceux de l'ancien exploitant.",
    EN: "Google already knew this establishment before the event: a new company runs an existing business. Check the contacts are not the previous operator's.",
  },
  watcherRowListedSince: { FR: "Sur Google", EN: "On Google" },
  watcherListedSince: {
    FR: "Avis depuis au moins le {date}",
    EN: "Reviewed since at least {date}",
  },
  watcherRowListedAs: { FR: "Google", EN: "Google" },
  watcherListedAs: {
    FR: "Connu sur Google sous le nom « {name} »",
    EN: "Known on Google as “{name}”",
  },
  watcherListedReviews: { FR: "{n} avis", EN: "{n} reviews" },
  watcherListedReview: { FR: "{n} avis", EN: "{n} review" },
  watcherEventToggle: { FR: "Événement", EN: "Event" },
  watcherRowSiren: { FR: "SIREN", EN: "SIREN" },
  watcherRowSiret: { FR: "SIRET", EN: "SIRET" },
  watcherRowNaf: { FR: "Code NAF", EN: "NAF code" },
  watcherRowNaf25: { FR: "NAF 2025", EN: "NAF 2025" },
  watcherRowActivity: { FR: "Activité", EN: "Activity" },
  watcherRowEnseigne: { FR: "Enseigne", EN: "Trade name" },
  watcherRowPublishedAt: { FR: "Publié le", EN: "Published on" },
  watcherRowManagers: { FR: "Dirigeants", EN: "Managers" },
  watcherRowSources: { FR: "Sources", EN: "Sources" },
  watcherRowPreviousOwner: { FR: "Ancien exploitant", EN: "Previous owner" },
  watcherRowBodacc: { FR: "Annonce", EN: "Notice" },
  watcherSourceSirene: { FR: "INSEE Sirene", EN: "INSEE Sirene" },
  watcherSourceBodacc: { FR: "BODACC", EN: "BODACC" },
  companyDirectorsPartial: {
    FR: "(liste partielle)",
    EN: "(partial list)",
  },
  companyTabPappers: { FR: "Pappers", EN: "Pappers" },
  companyTabSociete: { FR: "societe.com", EN: "societe.com" },
  decisionMakersToggle: { FR: "Personnes", EN: "People" },
  decisionMakerOriginHunter: { FR: "email", EN: "email" },
  decisionMakerOriginWebsearch: { FR: "recherche web", EN: "web search" },
  decisionMakerOriginPappers: { FR: "registre", EN: "registry" },
  decisionMakerOriginContact: { FR: "site web", EN: "website" },
  decisionMakerEmail: {
    FR: "Écrire à cette personne",
    EN: "Write to this person",
  },
  decisionMakerPhone: { FR: "Appeler cette personne", EN: "Call this person" },
  pappersOpenPage: { FR: "Voir sur Pappers", EN: "View on Pappers" },
  societeOpenPage: {
    FR: "Voir sur societe.com",
    EN: "View on societe.com",
  },
  pappersSectionIdentity: { FR: "Identité", EN: "Identity" },
  pappersSectionActivity: { FR: "Activité", EN: "Activity" },
  pappersSectionHeadOffice: { FR: "Siège", EN: "Head office" },
  pappersSectionFinance: {
    FR: "Effectif et finances",
    EN: "Workforce and finances",
  },
  pappersSectionPeople: { FR: "Dirigeants", EN: "Officers" },
  pappersRowSiren: { FR: "SIREN", EN: "SIREN" },
  pappersRowCompanyNumber: { FR: "Numéro d'entreprise", EN: "Company number" },
  pappersRowLegalForm: { FR: "Forme juridique", EN: "Legal form" },
  pappersRowStatus: { FR: "Statut", EN: "Status" },
  pappersRowCreatedAt: { FR: "Création", EN: "Incorporated" },
  pappersRowCeasedAt: { FR: "Cessation", EN: "Ceased" },
  pappersRowCapital: { FR: "Capital", EN: "Share capital" },
  pappersRowNaf: { FR: "Code NAF", EN: "NAF code" },
  pappersRowActivityDomain: { FR: "Domaine", EN: "Domain" },
  pappersRowActivities: { FR: "Activités", EN: "Activities" },
  pappersRowLocalActivities: {
    FR: "Activités (nomenclature locale)",
    EN: "Activities (local classification)",
  },
  pappersRowPurpose: { FR: "Objet social", EN: "Purpose" },
  pappersRowCollectiveAgreements: {
    FR: "Conventions collectives",
    EN: "Collective agreements",
  },
  pappersRowAddress: { FR: "Adresse", EN: "Address" },
  pappersRowSiret: { FR: "SIRET", EN: "SIRET" },
  pappersRowVatNumber: { FR: "N° TVA", EN: "VAT number" },
  pappersRowDeclaredActivity: {
    FR: "Activité déclarée",
    EN: "Declared activity",
  },
  pappersRowEstablishments: { FR: "Établissements", EN: "Establishments" },
  pappersRowWorkforce: { FR: "Effectif", EN: "Workforce" },
  pappersRowRevenue: { FR: "Chiffre d'affaires", EN: "Revenue" },
  pappersRowProfit: { FR: "Résultat", EN: "Profit" },
  pappersRowFinanceYear: { FR: "Exercice", EN: "Financial year" },
  pappersRowDirector: { FR: "Dirigeant", EN: "Officer" },
  pappersRowDirectors: { FR: "Dirigeants", EN: "Officers" },
  pappersRowDirectorsCount: { FR: "Nombre de dirigeants", EN: "Officer count" },
  pappersRowBeneficiariesCount: {
    FR: "Bénéficiaires effectifs",
    EN: "Beneficial owners",
  },
  pappersRowPublicationsCount: { FR: "Publications", EN: "Publications" },
  mailingCopyToggle: { FR: "Copies email", EN: "Email copies" },
  mailingCounter: {
    FR: "E-mail {n} sur {total}",
    EN: "Email {n} of {total}",
  },
  mailingPager: { FR: "E-mails de la séquence", EN: "Sequence emails" },
  mailingPrevious: { FR: "E-mail précédent", EN: "Previous email" },
  mailingNext: { FR: "E-mail suivant", EN: "Next email" },
  mailingTo: { FR: "À : {email}", EN: "To: {email}" },
  mailingSubject: { FR: "Objet : {subject}", EN: "Subject: {subject}" },
  topUpUnlock: {
    FR: "Rechargez pour débloquer ce lead.",
    EN: "Top up to unlock this lead.",
  },
  customQueryHint: { FR: "Question posée", EN: "Question asked" },
  customQuerySource: { FR: "Voir la source", EN: "View source" },
  customQueryShowMore: { FR: "+{n} autres", EN: "+{n} more" },
  customQueryShowFull: { FR: "Voir tout", EN: "Show full" },
  customQueryShowLess: { FR: "Réduire", EN: "Show less" },
  customVerdictYes: { FR: "Oui", EN: "Yes" },
  customVerdictNo: { FR: "Non", EN: "No" },
} satisfies FullTranslation

export const IMPORT_SUMMARY_T = {
  importTitle: { FR: "Base importée", EN: "Imported database" },
  importRecordsTotal: { FR: "lignes importées", EN: "records imported" },
  importRecordsSeeded: { FR: "en enrichissement", EN: "being enriched" },
  importRecordsSkipped: {
    FR: "ignorées (pas de site web)",
    EN: "skipped (no website)",
  },
  importRecordsFailed: { FR: "inutilisables", EN: "unusable" },
  importRecordsSynced: { FR: "resynchronisées", EN: "synced back" },
  importDuplicatesFound: { FR: "doublons trouvés", EN: "duplicates found" },
  importDuplicatesSkipped: { FR: "doublons ignorés", EN: "duplicates skipped" },
  importMatchedLeads: { FR: "leads enrichis", EN: "enriched leads" },
  importSyncBack: {
    FR: "Resynchroniser vers la source",
    EN: "Sync back to source",
  },
  importSyncBackStarted: {
    FR: "Resynchronisation lancée. Les compteurs se mettront à jour ici.",
    EN: "Sync back started. Counts will update here.",
  },
  importDownloadEnriched: {
    FR: "Télécharger le fichier enrichi",
    EN: "Download enriched file",
  },
  manualTitle: { FR: "Leads que vous avez ajoutés", EN: "Leads you added" },
  manualRecordsTotal: { FR: "leads ajoutés", EN: "leads added" },
  manualRecordsPending: { FR: "en attente", EN: "waiting" },
  manualRecordsMerged: {
    FR: "fusionnés avec un lead existant",
    EN: "merged into an existing lead",
  },
} satisfies FullTranslation

export const REENRICH_T = {
  reenrichTitle: { FR: "Ré-enrichir les leads", EN: "Re-enrich leads" },
  reenrichDescAll: {
    FR: "Relance les plugins choisis sur les {n} leads de la campagne avec la configuration actuelle. Chaque lead est facturé à nouveau par plugin, et le résultat précédent est remplacé.",
    EN: "Re-runs the chosen plugins on the campaign's {n} leads with the current configuration. Each lead is billed again per plugin, and the previous result is replaced.",
  },
  reenrichDescSelected: {
    FR: "Relance les plugins choisis sur les {n} leads sélectionnés avec la configuration actuelle. Chaque lead est facturé à nouveau par plugin, et le résultat précédent est remplacé.",
    EN: "Re-runs the chosen plugins on the {n} selected leads with the current configuration. Each lead is billed again per plugin, and the previous result is replaced.",
  },
  reenrichGroupActive: {
    FR: "Plugins de la campagne",
    EN: "Campaign plugins",
  },
  reenrichGroupAddable: {
    FR: "Ajouter à la campagne",
    EN: "Add to the campaign",
  },
  reenrichNewPluginsHint: {
    FR: "Pas encore actifs sur cette campagne. En choisir un l'active aussi pour les prochains leads.",
    EN: "Not active on this campaign yet. Picking one also turns it on for the next leads.",
  },
  reenrichChanged: { FR: "Modifié", EN: "Changed" },
  reenrichPerLead: {
    FR: "{cost} crédits par lead",
    EN: "{cost} credits per lead",
  },
  reenrichEligible: {
    FR: "{n} leads, {cost} crédits",
    EN: "{n} leads, {cost} credits",
  },
  reenrichIneligible: {
    FR: "{n} ignorés car non éligibles (non facturés)",
    EN: "{n} skipped as ineligible (not billed)",
  },
  reenrichNothingChanged: {
    FR: "Aucun plugin n'a changé depuis l'enrichissement de ces leads. Vous pouvez tout de même en relancer un.",
    EN: "No plugin changed since these leads were enriched. You can still re-run one.",
  },
  reenrichBlockedCampaignActive: {
    FR: "Mettez la campagne en pause pour ré-enrichir ses leads.",
    EN: "Pause the campaign to re-enrich its leads.",
  },
  reenrichBlockedAlreadyRunning: {
    FR: "Un ré-enrichissement est déjà en cours. Attendez qu'il se termine.",
    EN: "A re-enrichment is already running. Wait for it to finish.",
  },
  reenrichBlockedTickRunning: {
    FR: "Une recherche est encore en cours sur cette campagne. Attendez qu'elle se termine.",
    EN: "A search is still running on this campaign. Wait for it to finish.",
  },
  reenrichNoPlugin: {
    FR: "Cette campagne n'a aucun plugin relançable.",
    EN: "This campaign has no plugin that can be re-run.",
  },
  reenrichPushedNotice: {
    FR: "{n} séquences déjà envoyées à l'outil d'outreach gardent la copie envoyée. Seules les autres sont réécrites.",
    EN: "{n} sequences already pushed to the outreach tool keep the copy they were sent with. Only the others are rewritten.",
  },
  reenrichRefundNotice: {
    FR: "Un plugin qui échoue ou ne peut pas s'exécuter sur un lead est remboursé automatiquement.",
    EN: "A plugin that fails or cannot run on a lead is refunded automatically.",
  },
  reenrichBalance: {
    FR: "Solde : {n} crédits",
    EN: "Balance: {n} credits",
  },
  reenrichInsufficient: {
    FR: "Crédits insuffisants pour ce ré-enrichissement.",
    EN: "Not enough credits for this re-enrichment.",
  },
  reenrichTopUp: { FR: "Recharger", EN: "Top up" },
  reenrichStarted: {
    FR: "Ré-enrichissement lancé",
    EN: "Re-enrichment started",
  },
  reenrichRunning: {
    FR: "Ré-enrichissement, {n} restants",
    EN: "Re-enriching, {n} left",
  },
  reenrichCancel: { FR: "Annuler", EN: "Cancel" },
  reenrichAction: { FR: "Ré-enrichir", EN: "Re-enrich" },
  selectLead: { FR: "Sélectionner ce lead", EN: "Select this lead" },
  selectAll: { FR: "Tout sélectionner", EN: "Select all" },
  deselectAll: { FR: "Tout désélectionner", EN: "Deselect all" },
  savePlugins: { FR: "Enregistrer", EN: "Save" },
  cancelEdit: { FR: "Annuler", EN: "Cancel" },
  pluginsSaved: { FR: "Plugins mis à jour", EN: "Plugins updated" },
  editPluginsHint: {
    FR: "Les changements s'appliquent aux prochains leads. Ré-enrichissez les leads existants pour les mettre à jour.",
    EN: "Changes apply to the next leads. Re-enrich existing leads to update them.",
  },
  fixedAtCreation: {
    FR: "Fixé à la création de la campagne.",
    EN: "Set when the campaign was created.",
  },
  pluginRating: { FR: "Notes", EN: "Ratings" },
  pluginDecisionMakers: { FR: "Décideurs", EN: "Decision-makers" },
  pluginWebsiteQuality: { FR: "Audit du site", EN: "Website audit" },
  pluginSocials: { FR: "Profils sociaux", EN: "Social profiles" },
  pluginAdCheck: { FR: "Vérification publicitaire", EN: "Ad check" },
  pluginAdCheckHelp: {
    FR: "Vérifie si chaque entreprise paie des publicités (Meta, Google, Pages Jaunes).",
    EN: "Checks whether each business pays for ads (Meta, Google, Pages Jaunes).",
  },
  pluginJobOffers: { FR: "Offres d'emploi", EN: "Job offers" },
  pluginPappers: { FR: "Fiche entreprise", EN: "Company record" },
  pluginCustomQuery: { FR: "Requête personnalisée", EN: "Custom query" },
  pluginMailingCopy: { FR: "Copie e-mail", EN: "Email copy" },
} satisfies FullTranslation
